export default __webpack_public_path__ + "static/media/discounts-snack5-image.3ba7c28b.svg";